import React, { useState } from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Tengo que comprar suplementos caros?',
  answer: 'No, todo lo que necesitas está en tu supermercado local.'
}, {
  question: '¿Voy a pasar hambre?',
  answer: 'No, el plan se enfoca en la densidad nutricional para mantenerte satisfecho.'
}, {
  question: '¿Puedo tomar café?',
  answer: 'Sí, te enseñamos cómo tomarlo para que no te inflame.'
}, {
  question: '¿Cuánto peso voy a perder?',
  answer: 'No es un plan de pérdida de grasa a largo plazo, sino de pérdida de inflamación líquida (usualmente 3-5 libras en el fin de semana).'
}, {
  question: '¿Es difícil de seguir?',
  answer: 'Está diseñado para personas ocupadas; es simple, directo y sin complicaciones.'
}, {
  question: '¿Qué pasa después de las 48 horas?',
  answer: 'Recibirás la regla 80/20 para mantenerte bien el resto de la semana.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionWrapper className="bg-brand-cream" data-id="element-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center mb-12" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-27">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-29">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-30">
                <span className="font-bold text-lg text-gray-900" data-id="element-31">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-teal transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-32" />
              </button>

              <AnimatePresence data-id="element-33">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-34">
                    <div className="px-6 pb-6 text-gray-600 text-lg" data-id="element-35">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}